import List from 'list.js'

if ( jQuery('#members-list .list').length !== 0 ) {
    var sortValue = jQuery( '#sort_members' ).val()

    var memberSearch = new List( 'members-list', {
        valueNames: [ 'member__name', 'member__organization', 'member__phone', 'member__website', 'member__designation' ],
        fuzzySearch: {
            location  : 0,
            threshold : 0.2,
        }
    }).on('searchComplete', function () {

        if( sortValue == 'organization' )
            addUnique( 'org' )
        else
            addUnique( 'letter' )

    }).on('sortComplete', function () {

        if( sortValue == 'organization' )
            addUnique( 'org' )
        else
            addUnique( 'letter' )

    })

    addUnique( 'letter' )

    jQuery('#sort_members').on('change', function(e) {
        sortValue = jQuery( '#sort_members' ).val()

        if( sortValue == 'organization' )
            memberSearch.sort( 'member__organization' )
        else
            memberSearch.sort( 'member__name' )
    })

}

function addUnique( attr ) {

    let els = jQuery('.member'),
        letterIndex = ''

    els.each(function () {

        let el = jQuery(this),
            letter = el.data(attr)

        if( letter == '' && sortValue == 'organization' )
            letter = 'Other Members'

        if ( letterIndex === '' ) {

            letterIndex = letter
            el.before(`<div class="unique">${letter}</div>`)

        } else if ( letterIndex !== letter ) {

            letterIndex = letter
            el.before(`<div class="unique">${letter}</div>`)

        }

    })

}
